import { setBaseURL, setIntercept } from './../services/api'
import axios from 'axios';

export function initialize(store, router) {
    router.beforeEach((to, from, next) => {
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const currentUser = store.state.currentUser;

        if (requiresAuth && !currentUser) { // se a rota requer autenticação e não há usuário logado
            next({ name: 'Login' }); // redireciona para a página de login
        } else if (to.name === 'Login' && currentUser) { // se a rota é a página de login e há usuário logado

            next({ name: 'Minhas Unidades' }); // redireciona para a página 'Home'
        } else {
            next(); // permite a navegação normalmente
        }
    });

    setBaseURL();
    setIntercept(store, router);
    if (store.getters.getCurrentUser) {
        setAuthorization(store.getters.getCurrentUser.token);
    }
}

export function setAuthorization(token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}
